import { Button, SimpleGrid, Stack, Text } from "@mantine/core";
import { IconFileDescription, IconNotes } from "@tabler/icons-react";
import { useState } from "react";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import type { ContractModalMode } from "../Direktvermarktung.types";

interface VermarktungContractModalModeSelectionProps {
  onConfirm: (mode: ContractModalMode) => void;
  onCancel: (contractId?: string) => void;
}

function VermarktungContractModalModeSelection({
  onConfirm,
  onCancel
}: VermarktungContractModalModeSelectionProps) {
  const [localMode, setLocalMode] = useState<ContractModalMode | undefined>();

  return (
    <>
      <SimpleGrid className="VermarktungContractModalModeSelection" cols={2}>
        <Button
          fw={500}
          h="100%"
          px="paddingSm"
          py="paddingXs"
          variant={localMode === "manual" ? "outline" : "default"}
          onClick={() => setLocalMode("manual")}
        >
          <Stack align="center" w="100%">
            <IconNotes />
            Manuelle Eingabe
            <Text c="dimmed" style={{ textWrap: "wrap" }}>
              Vertragsdaten und Form für Entgelt eigenständig eintragen
            </Text>
          </Stack>
        </Button>
        <Button
          fw={500}
          h="100%"
          px="paddingSm"
          py="paddingXs"
          variant={localMode === "template" ? "outline" : "default"}
          onClick={() => setLocalMode("template")}
        >
          <Stack align="center" w="100%">
            <IconFileDescription />
            Vertragsdaten kopieren
            <Text c="dimmed" style={{ textWrap: "wrap" }}>
              Vertragsdaten aus bestehendem Vertrag kopieren
            </Text>
          </Stack>
        </Button>
      </SimpleGrid>
      <ModalFooter justify="space-between">
        <Button variant="default" onClick={() => onCancel()}>
          Abbrechen
        </Button>
        <Button
          disabled={localMode === undefined}
          onClick={() =>
            localMode !== undefined ? onConfirm(localMode) : undefined
          }
        >
          Weiter
        </Button>
      </ModalFooter>
    </>
  );
}

export { VermarktungContractModalModeSelection };
